import {Experiment} from "@amplitude/experiment-js-client";

/** @type {import("@amplitude/experiment-js-client").ExperimentClient} */
let experimentClient = null;

/**
 * Fetch the latest experiment configurations from the server
 * @returns {Promise<import("@amplitude/experiment-js-client").ExperimentClient>}
 */
const fetchExperiments = async () => {
	if (!experimentClient) {
		initializeExperiment();
	}
	return experimentClient.fetch();
};

/**
 * Get the variant for a specific flag
 * @param {string} flagKey
 * @returns {import("@amplitude/experiment-js-client").Variant} The variant
 */
const getVariant = (flagKey) => {
	if (!experimentClient) {
		initializeExperiment();
	}
	return experimentClient.variant(flagKey);
};

/**
 * Get the variant for a specific flag
 * @param {string} flagKey
 * @param {*} defaultValue - Default value to return if the flag is not found
 * @returns {*} The variant value or the default value
 */
const getVariantValue = (flagKey, defaultValue = null) => {
	if (!experimentClient) {
		initializeExperiment();
	}
	const variant = getVariant(flagKey);
	return variant?.value ?? defaultValue;
};

/**
 * @returns {import("@amplitude/experiment-js-client").ExperimentClient} The variant
 */
const initializeExperiment = () => {
	if (!experimentClient) {
		experimentClient = Experiment.initialize(process.env.REACT_APP_FUNNEL_AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY);
	}
	return experimentClient;
};

/**
 * @param {string} userId
 */
const setExperimentUser = (userId) => {
	if (!experimentClient) {
		initializeExperiment();
	}
	experimentClient.setUser({
		user_id: userId,
	});
};

/**
 * Track an exposure event for a specific flag or banner
 * @param {string} flagKey
 */
const trackExposure = (flagKey) => {
	if (!experimentClient) {
		initializeExperiment();
	}
	experimentClient.exposure(flagKey);
};

export {
	fetchExperiments,
	getVariant,
	getVariantValue,
	initializeExperiment,
	setExperimentUser,
	trackExposure,
};